import { DateTime } from "luxon";
import { PhaseListForms } from "../Responses/types";

export const mapScreeningPhaseFormToCard = (
  phaseForm: any,
  phase: { id: string; name: string },
  screeningAttemptId: string,
): PhaseListForms => {
  const formAttempt = phaseForm.form.formAttempts?.find(
    (attempt: any) => attempt?.screeningAttempt?.id === screeningAttemptId,
  );
  return {
    position: phaseForm.position,
    id: phaseForm.form.id,
    name: phaseForm.form.name,
    attempt: formAttempt?.id || "",
    status: formAttempt?.status || "active",
    locked: formAttempt?.isLocked || false,
    lockedBy: formAttempt?.lockedBy
      ? `${formAttempt.lockedBy.firstName ?? ""} ${formAttempt.lockedBy.lastName ?? ""}`.trim()
      : "",
    lockedAt: formAttempt?.lockedAt
      ? DateTime.fromISO(formAttempt.lockedAt).toFormat(
          "dd MMMM yyyy hh:mm a",
        )
      : "",
    isSigned: formAttempt?.isSigned || false,
    signedBy: formAttempt?.signedBy
      ? `${formAttempt.signedBy.firstName ?? ""} ${formAttempt.signedBy.lastName ?? ""}`.trim()
      : "",
    signedAt: formAttempt?.signedAt
      ? DateTime.fromISO(formAttempt.signedAt).toFormat("dd MMMM yyyy hh:mm a")
      : "",
    isSubmitted: formAttempt?.isSubmitted ?? false,
    submittedAt: formAttempt?.submittedAt
      ? DateTime.fromISO(formAttempt.submittedAt).toFormat("dd MMMM yyyy hh:mm a")
      : "",
    phaseName: phase.name,
    phaseId: phase.id,
  };
};

export const formatScreeningFormCardDates = (
  card: PhaseListForms & { lockedAt?: string; signedAt?: string },
): PhaseListForms => {
  const format = (value?: string) =>
    value && value.includes("T")
      ? DateTime.fromISO(value).toFormat("dd MMMM yyyy hh:mm a")
      : value || "";

  return {
    ...card,
    lockedAt: format(card.lockedAt),
    signedAt: format(card.signedAt),
  };
};
